const LS_LASTTRACKID = "lastTrackId";

export const setTrackIDtoLS = (id) => {
  window.localStorage.setItem(LS_LASTTRACKID, JSON.stringify(id));
};

export const deleteTrackIDfromLS = () => {
  window.localStorage.removeItem(LS_LASTTRACKID);
};

export const getTrackIDfromLS = () => {
  return JSON.parse(localStorage.getItem(LS_LASTTRACKID));
};
